// imports section Start
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../assets/styles/Theme";
import MenuIcon from "@mui/icons-material/Menu";
import {
  Box,
  Grid,
  Typography,
  Button,
  IconButton,
  Stack,
  TextField,
  CircularProgress,
} from "@mui/material";
import { externalgetApi } from "../../services/external/externalApis";
import { KITCHEN_API_02 } from "../../api/ApiModel";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
// imports section End

export default function KitchenAside({ refreshTrigger }) {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const [summaryItems, setSummaryItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchSummaryItems();
  }, [refreshTrigger]);
  // Hooks end

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE } = SYS_USER.USER_PARAM || {};

  // API calls start

  const fetchSummaryItems = async () => {
    try {
      const response = await externalgetApi(KITCHEN_API_02, "GET", {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        STS: CON_STATUS_ACTIVE,
      });
      setSummaryItems(response);
      console.log(
        "fetchSummaryItemsfetchSummaryItems fetchSummaryItems:",
        response
      );
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
    // fetchSummaryItems();
  };
  // API calls end

  return (
    <Grid spacing={0} sx={styles.aside_content}>
      <Grid container sx={styles.aside_content_header}>
        <Grid xs={10} md={10} sx={styles.left_align}>
          <Typography
            sx={{
              ...theme.typography.h2,
              color: theme.palette.text.primary,
            }}
          >
            Summary
          </Typography>
        </Grid>
        {/* <Grid xs={2} md={2} sx={styles.right_align}>
          <IconButton sx={styles.summary_menu_icon}>
            <MenuIcon />
          </IconButton>
        </Grid> */}
      </Grid>

      <Box pt={2} px={1} sx={{ height: "85vh", overflow: "auto" }}>
        <Grid item>
          <Stack spacing={2}>
            {loading ? (
              <Box sx={styles.progress_circular}>
                <CircularProgress />
              </Box>
            ) : error ? (
              <Typography>Error fetching data: {error.message}</Typography>
            ) : (
              summaryItems.map((item, index) => (
                <Grid
                  key={`${item.ITEM}-${index}`}
                  sx={{
                    boxShadow: `0px 0px 4px 0px ${theme.palette.input_field.stroke}`,
                    pr: 1,
                  }}
                >
                  <Grid
                    sx={styles.ks_stack}
                    direction={{ xs: "row", sm: "row" }}
                    spacing={{ xs: 1, sm: 2, md: 4 }}
                    gap={2}
                  >
                    <Grid xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Typography
                        sx={{
                          ...theme.typography.caption,
                          color: theme.palette.text.primary,
                          fontWeight: 600,
                        }}
                      >
                        {item.ITEM}
                      </Typography>
                    </Grid>
                    <Grid xs={1} sm={1} md={1} lg={1} xl={1}>
                      <Box sx={styles.ks_qty_count}>
                        <Typography>{item.QTY}</Typography>
                      </Box>
                    </Grid>
                    {/* <Grid xs={2} sm={2} md={2} lg={2} xl={2}>
                      <TextField
                        id="outlined-basic"
                        size="small"
                        variant="outlined"
                        sx={styles.ks_textfield}
                      />
                    </Grid> */}
                    {/* <Grid
                      xs={2}
                      sm={2}
                      md={2}
                      lg={2}
                      xl={2}
                      sx={styles.right_align}
                    >
                      <Button
                        variant="contained"
                        size="small"
                        sx={{ ...styles.btn_primary, py: "9px" }}
                      >
                        Update
                      </Button>
                    </Grid> */}
                  </Grid>
                </Grid>
              ))
            )}
          </Stack>
        </Grid>
      </Box>
    </Grid>
  );
}
